import type { FooterLinks, LinkSegments } from '$lib/components/seo/types';
import type { LanguageCode } from '$lib/i18n/language';
import { segments2route } from '$lib/components/seo/linkSegments';
import * as m from '$paraglide/messages';

export function getReturnRouteLinks(returnRouteTitle: string, locale: LanguageCode, departureSegments?: LinkSegments, arrivalSegments?: LinkSegments): FooterLinks | undefined {
	if (!departureSegments || !arrivalSegments) {
		return undefined;
	}

	return {
		label: returnRouteTitle,
		links: [
			{
				href: segments2route(arrivalSegments, departureSegments, locale),
				label: `${m.search_tools__button__aria_label({}, { locale })} ${arrivalSegments.at(-1)?.label} ${departureSegments.at(-1)?.label}`,
			},
		],
	};
}
